import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=6a27ee9d&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports